import { get_axios_instance, api_variables } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_EMPLOYEES_DATA);
var axios_instance_search = get_axios_instance(api_variables.SERVICE_EMPLOYEE_BY_NAME);

const _pk_name = "id";

const state = {
  data:[],
  searchList: [],
  exits: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },

  setSearchList: (state, payload) => {
    state.searchList = payload;
    //console.log('fetched data', state.data)
  },

  setExits: (state, payload) => {
    if(payload) {
      state.exits = payload;
    }
    //console.log('fetched exits', state.exits)
  },

  addEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.exits = payload;
  },

  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const actions = {
  async fetchAll({commit}, payload) {
      //console.log("[state/dashboard/payroll/employees/fetchAll] Calling API...",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance.get(`/`, {
        params: {
          le_id:payload
        }
      });
       commit("setFetching", false);
      //console.log("[state/dashboard/payroll/employees/fetchAll] res: ", res);
      if(res.status == 200) {
        commit("set", payload);
      }
     commit("set", res.data.rows);
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async searchEmployee({commit}, payload) {
      //console.log("[state/dashboard/payroll/employees/searchEmployee] Calling API...",payload);
    try {
      commit("setFetching", true);
      let res = await axios_instance_search.get(`/`, {
        params: {
          le_id:payload
        }
      });
       commit("setFetching", false);
      //console.log("[state/dashboard/payroll/employees/searchEmployee] res: ", res);
      if(res.status == 200) {
        commit("setSearchList", payload);
      }
     commit("setSearchList", res.data.rows);
      return res;
    }catch (err){
        //console.log(err);
    }
  },

  async create({commit}, payload) {
      //console.log("[state/payroll/payGroup/create] Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.post('/', payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/create] res: ", res);
      if(res.status == 200) {
        commit("addEmployee", payload);
      }
      return res;
    }catch (err){
        //console.log(err);

    }
  },

  async update({commit}, payload) {
      //console.log("[state/payroll/payGroup/update] Updating... Display payload", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance.put(`/${payload.id}`, payload);
      commit("setSaving", false);
      //console.log("[state/payroll/payGroup/update] res: ", res);
      if(res.status == 200) {
        commit("updateEmployeeById", res.data);
      }
      return res;
    }catch (err){
        //console.log(err);

    }
  },

  async delete({commit}, payload) {
    //console.log("[state/payroll/payGroup/delete] Payload:", payload);
    //console.log("[state/payroll/payGroup/delete] Payload:", `/${payload.id}`);
    try {
      commit("setDeleting", true);
      let res = await axios_instance.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200){
        commit("removeEmployeeById", payload.id);
      }
    }catch (err){
        //console.log(err);

    }
  }
}

export default {
  namespaced: true,
  state, mutations, actions
}
